import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';

import { Router } from '@angular/router';
import { MyReturnService } from '@app/core/services/my-return.service';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { MyReturnActionTypes, AuthActionTypes } from '../actions';

/**
 * MyReturnEpics
 */
@Injectable()
export class MyReturnEffects {
  /**
   * constructor
   * @param {MyReturnService} brandsService
   */
  constructor(private brandsService: MyReturnService, private actions$: Actions, private router: Router) {}

  /**
   * loadMyReturn
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  loadMyReturn = createEffect(() =>
    this.actions$.pipe(
      ofType(MyReturnActionTypes.LOAD_MY_RETURN),
      switchMap(() => {
        return this.brandsService.getMyReturn().pipe(
          map(refresh => ({
            type: MyReturnActionTypes.LOAD_MY_RETURN_SUCCESS,
            payload: refresh,
          })),
          catchError(err =>
            of({
              type: MyReturnActionTypes.LOAD_MY_RETURN_ERROR,
              payload: err,
            }),
          ),
        );
      }),
    ),
  );

  /**
   * loadMyReturnError
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  loadMyReturnError = createEffect(() =>
    this.actions$.pipe(
      ofType(MyReturnActionTypes.LOAD_MY_RETURN_ERROR),
      map(() => ({ type: AuthActionTypes.LOGOUT })),
    ),
  );
}
